import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Col, Row, Card, Image, ListGroup, ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'


import logo from '../imgs/IRN-logo-2020-1-2-275x300.png'
import Locations from './Locations';

function TimeTable() {
    var gettoday = new Date();
    let dayWeek = gettoday.getDay();
    var dd = String(gettoday.getDate()).padStart(2, '0');
    var mm = String(gettoday.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = gettoday.getFullYear();

    //var mmInt = parseInt(mm) - 1;

    //const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    const weekday = ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"];
    const weekdayshort = ["søn", "man", "tir", "ons", "tor", "fre", "lør"];
    const monthText = ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];

    //const [today, setToday] = useState(gettoday);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([])
    const [dataMonthly, setDataMonthly] = useState([])
    const [mmNum, setMmNum] = useState(mm)
    const [locid, setLocid] = useState(181)
    const [locname, setLocname] = useState('Oslo')

    const headers = {
        'Api-Token': '50c0f89e-1bac-4125-9128-3612c21c20bc'
    };

    function stringToDate(_date, _format, _delimiter) {
        var formatLowerCase = _format.toLowerCase();
        var formatItems = formatLowerCase.split(_delimiter);
        var dateItems = _date.split(_delimiter);
        var monthIndex = formatItems.indexOf("mm");
        var dayIndex = formatItems.indexOf("dd");
        var yearIndex = formatItems.indexOf("yyyy");
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
        return formatedDate;
    }

    function changeMonth(e) {

        //console.log(e.target.value, mm, dd)
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + e.target.value, { headers });
                var responseNew = response.map((v) => ({ ...v, dateNorsk: v.date.substring(0, 5).replace('-', '.'), day: weekdayshort[stringToDate(v.date, "dd-mm-yyyy", "-").getDay()] }))
                //setDataMonthly(response);
                setDataMonthly(responseNew);
                //console.log(response)
                //.log(responseNew)
                //console.log(new Date("2022-03-02").getDay())
                //console.log(stringToDate("24-03-2022", "dd-mm-yyyy", "-").getDay())
            } catch (error) {
                console.log(error)
                //console.error(error.message);
            }
            setLoading(false);
        }

        fetchData();
        setMmNum(e.target.value)
    }

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        //console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        //console.log(result)
    }

    /* const onItemClick = useCallback(event => {        
        const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + mmNum + '/' + dd, { headers });
                //setData(response);
                setData(response);
      }, [data]); */

    const handleOnSelect = (item) => {
        // the item selected
        //console.log(item)
        setLocid(item.id)
        setLocname(item.name)

        const fetchDataMonthly = async () => {
            //setLoading(true);
            try {
                //const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + mmNum, { headers });
                const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + item.id + '/' + String(yyyy) + '/' + mmNum, { headers });
                var responseNew = response.map((v) => ({ ...v, dateNorsk: v.date.substring(0, 5).replace('-', '.'), day: weekdayshort[stringToDate(v.date, "dd-mm-yyyy", "-").getDay()] }))
                //setDataMonthly(response);
                setDataMonthly(responseNew);

                //console.log(response)
                //console.log(responseNew)
                //console.log(new Date("2022-03-02").getDay())
                //console.log(stringToDate("24-03-2022", "dd-mm-yyyy", "-").getDay())
            } catch (error) {
                //console.log(error)
                //console.error(error.message);
            }
            //setLoading(false);
        }

        fetchDataMonthly();

        const fetchData = async () => {
            //setLoading(true);
            try {
                //const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + mmNum + '/' + dd, { headers });
                const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + item.id + '/' + String(yyyy) + '/' + mmNum + '/' + dd, { headers });
                //setData(response);
                setData(response);
                return response;
                //console.log(response)
            } catch (error) {
                console.log(error)
                //console.error(error.message);
            }
            //setLoading(false);
        }

        setData(fetchData());

    }

    const handleOnFocus = () => {
        //console.log('Focused')
    }

    const formatResult = (item) => {
        //console.log(item.name);
        //console.log(item.id);
        return (
            <>


                <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
                <span style={{ display: 'block', textAlign: 'left' }}><small>{item.lat}&deg;N, {item.lon}&deg;E</small></span>


            </>
        )
        /*         return (
                    <div className="result-wrapper">
                        <span className="result-span">id: {item.id}</span>
                        <span className="result-span">name: {item.name}</span>
                    </div>
                ); */
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + mmNum + '/' + dd, { headers });
                setData(response);
                //console.log(response)
            } catch (error) {
                console.log(error)
                //console.error(error.message);
            }
            setLoading(false);
        }

        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get('https://api.bonnetid.no//prayertimes/' + locid + '/' + String(yyyy) + '/' + mmNum, { headers });
                var responseNew = response.map((v) => ({ ...v, dateNorsk: v.date.substring(0, 5).replace('-', '.'), day: weekdayshort[stringToDate(v.date, "dd-mm-yyyy", "-").getDay()] }))
                //setDataMonthly(response);
                setDataMonthly(responseNew);
                //console.log(response)
                //console.log(responseNew)
                //console.log(new Date("2022-03-02").getDay())
                //console.log(stringToDate("24-03-2022", "dd-mm-yyyy", "-").getDay())
            } catch (error) {
                console.log(error)
                //console.error(error.message);
            }
            setLoading(false);
        }

        fetchData();
    }, []);

    const columns = [
        {
            name: 'Dato',
            selector: row => row.dateNorsk,
        }, {
            name: 'Dag',
            selector: row => row.day,
        },
        {
            name: 'Fajr',
            selector: row => row.fajr,
        },
        {
            name: 'Shuruuq',
            selector: row => row.shuruq_sunrise,
        },
        {
            name: 'Duhr',
            selector: row => row.duhr,
        },
        {
            name: 'Asr',
            selector: row => row.asr_wusta_noon_sunset,
        },
        {
            name: 'Maghrib',
            selector: row => row.maghrib,
        },
        {
            name: 'Isha',
            selector: row => row.isha,
        },
    ];

    const conditionalRowStyles = [
        {
            when: row => row.day === "fre",
            style: {
                backgroundColor: 'rgba(63, 195, 128, 0.9)',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
        }, {
            when: row => row.dateNorsk === dd + "." + mm,
            style: {
                backgroundColor: 'rgba(228, 228, 228, 0.9)',
                color: 'black',
                fontWeight: 'bold',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
        },
    ];

    return (
        <div>
            <Container>
                <Row>
                    {/* <Col md={3} className="bg-light vh-100"> */}
                    <Col md={3} className="bg-light" style={{height:"1000px"}}>
                        <a href="https://www.irn.no/" rel="noopener noreferrer">
                            <Image src={logo} style={{ height: "100px" }} className="m-3"></Image>
                        </a>
                        <Card>
                            <Card.Title className="pt-3 pb-3 mb-0 bg-dark text-white">
                                {locname}
                            </Card.Title>
                            <ListGroup variant="flush">
                                <ListGroup.Item className="bg-secondary text-white"><Row><Col style={{ textAlign: "right" }}><h5>{weekday[dayWeek]}</h5></Col><Col style={{ textAlign: "left" }}><h5>{data.date}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Fajr</Col><Col style={{ textAlign: "left" }}><h5>{data.fajr}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Shuruuq</Col><Col style={{ textAlign: "left" }}><h5>{data.shuruq_sunrise}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Duhr</Col><Col style={{ textAlign: "left" }}><h5>{data.duhr}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Asr-1x skygge</Col><Col style={{ textAlign: "left" }}><h5>{data.asr_1x_shadow}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Asr-2x skygge</Col><Col style={{ textAlign: "left" }}><h5>{data.asr_2x_shadow}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Asr</Col><Col style={{ textAlign: "left" }}><h5>{data.asr_wusta_noon_sunset}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Maghrib</Col><Col style={{ textAlign: "left" }}><h5>{data.maghrib}</h5></Col></Row></ListGroup.Item>
                                <ListGroup.Item><Row><Col style={{ textAlign: "right" }}>Isha</Col><Col style={{ textAlign: "left" }}><h5>{data.isha}</h5></Col></Row></ListGroup.Item>
                            </ListGroup>
                        </Card>
                        <div className="mt-3 mb-1">Velg en by:</div>
                        <ReactSearchAutocomplete
                            items={Locations}
                            onSearch={handleOnSearch}
                            onHover={handleOnHover}
                            onSelect={handleOnSelect}
                            onFocus={handleOnFocus}
                            formatResult={formatResult}
                            fuseOptions={{ shouldSort: true, keys: ["name"] }}
                            maxResults={3}
                            autoFocus
                            style={{ zIndex: "1" }}
                        //fuseOptions={{ [shouldSort = True, keys = "name"]}}
                        />
                    </Col>
                    <Col md={9}>
                        <Card>
                            <Card.Title className="pt-3 pb-1 mb-0 bg-dark text-white">
                                <Row><Col style={{ textAlign: "left", marginLeft: "20px" }}><h5>{locname.toUpperCase()}</h5></Col><Col style={{ textAlign: "right", marginRight: "20px" }} ><h5>{monthText[parseInt(mmNum) - 1]} {yyyy}</h5></Col></Row>
                            </Card.Title>
                        </Card>
                        <ButtonToolbar aria-label="Toolbar with button groups">
                            <ButtonGroup className="w-100" aria-label="First group" size="sm" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <Button variant="secondary" onClick={changeMonth} value="01">JANUAR</Button>
                                <Button variant="secondary" onClick={changeMonth} value="02">FEBRUAR</Button>
                                <Button variant="secondary" onClick={changeMonth} value="03">MARCH</Button>
                                <Button variant="secondary" onClick={changeMonth} value="04">APRIL</Button>
                                <Button variant="secondary" onClick={changeMonth} value="05">MAI</Button>
                                <Button variant="secondary" onClick={changeMonth} value="06">JUNI</Button>
                                <Button variant="secondary" onClick={changeMonth} value="07">JULI</Button>
                                <Button variant="secondary" onClick={changeMonth} value="08">AUGUST</Button>
                                <Button variant="secondary" onClick={changeMonth} value="09">SEPTEMBER</Button>
                                <Button variant="secondary" onClick={changeMonth} value="10">OKTOBER</Button>
                                <Button variant="secondary" onClick={changeMonth} value="11">NOVEMBER</Button>
                                <Button variant="secondary" onClick={changeMonth} value="12">DESEMBER</Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                        <DataTable
                            conditionalRowStyles={conditionalRowStyles}
                            fixedHeader
                            columns={columns}
                            data={dataMonthly}
                            dense
                        //pagination
                        //selectableRows
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default TimeTable;